<template>
  <CCol col="12" xl="12" class="p-0">
    <CCard class="p-0">
      <CCardHeader
        class="d-flex justify-content-between align-items-center bg-secondary"
      >
        <h5 class="text-light m-0 p-0">تنظیم سنسور</h5>
      </CCardHeader>
      <CForm class="needs-validation p-2" novalidate>
        <CRow>
          <div class="col-sm-12 col-md-6 col-lg-4">
            <label class="typo__label">شماره سنسور</label>
            <multiselect
              class="needs-validation"
              v-model="indexValue"
              :options="indexList"
              :searchable="true"
              :allow-empty="false"
              :close-on-select="true"
              :show-labels="false"
              placeholder="انتخاب..."
              label="label"
              track-by="value"
              :disabled="disableMultiselect"
              @select="createTable($event)"
            ></multiselect></div
        ></CRow>

        <h5 class="text-primary mt-3">تنظیمات</h5>
        <hr />
        <CRow class="mt-1">
          <div class="col-sm-12 col-md-6 col-lg-4">
            <label class="typo__label">نوع سنسور</label>
            <multiselect
              class="needs-validation"
              v-model="typeValue"
              :options="typeList"
              :searchable="true"
              :allow-empty="false"
              :close-on-select="true"
              :show-labels="false"
              placeholder="انتخاب..."
              label="label"
              track-by="value"
              :disabled="disableMultiselect"
            ></multiselect>
          </div>
          <CInputCheckbox
            label="فعال"
            class="mt-4 mr-2 pt-3 col-sm-12 col-md-6 col-lg-4 px-4"
            :checked="active"
            @change="active = !active"
          />
        </CRow>
        <CRow class="mt-2 p-2">
          <table class="table table-striped m-2">
            <thead>
              <tr>
                <th scope="col">ردیف</th>
                <th scope="col">سنسور</th>
                <th scope="col">رله-بالا</th>
                <th scope="col">رله پایین</th>
                <th scope="col">آلارم-بالا</th>
                <th scope="col">آلارم-پایین</th>
                <th scope="col">کالیبراسیون</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in selectedSensors" :key="item.name">
                <!-- <th scope="row">{{i+1}}</th> -->
                <td>{{ i + 1 }}</td>
                <td>{{ item.name }}</td>
                <td>
                  <CInput
                    type="number"
                    v-model="settingValues[i].relayUp"
                    :value="settingValues[i].relayUp"
                  />
                </td>
                <td>
                  <CInput
                    type="number"
                    v-model="settingValues[i].relayDown"
                    :value="settingValues[i].relayDown"
                  />
                </td>
                <td>
                  <CInput
                    type="number"
                    v-model="settingValues[i].alarmUp"
                    :value="settingValues[i].alarmUp"
                  />
                </td>
                <td>
                  <CInput
                    type="number"
                    v-model="settingValues[i].alarmDown"
                    :value="settingValues[i].alarmDown"
                  />
                </td>
                <td>
                  <CInput
                    type="number"
                    v-model="settingValues[i].collibration"
                    :value="settingValues[i].collibration"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </CRow>
        <CRow class="justify-content-center mt-2">
          <CButton
            @click="clearForm()"
            color="secondary"
            class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
            ><CIcon name="cil-loop-circular" class="mx-2" />پاک کردن</CButton
          >
          <CButton
            color="primary"
            @click="submitForm()"
            class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
            ><CIcon name="cil-check-circle" class="mx-2" /> ثبت</CButton
          >
        </CRow>
      </CForm>
    </CCard>

    <!-- Alert modal -->
    <CModal
      :title="alertModalTitle"
      :color="alertModalColor"
      :show.sync="alertModal"
    >
      {{ alertModalText }}

      <template #footer>
        <CButton
          @click="redirectToCarsPage"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
      </template>
    </CModal>
  </CCol>
</template>

<script>
import axios from "axios";
import { Values } from "../../commonValues";
import router from "../../router";
import Multiselect from "vue-multiselect";
import vMultiselectListbox from "vue-multiselect-listbox";

export default {
  props: ["serialNumber, sensorType, sensorIndex"],

  components: {
    vMultiselectListbox,
    Multiselect,
  },

  data() {
    return {
      alertModal: false,
      alertModalTitle: "",
      alertModalText: "",
      alertModalColor: "",
      alertModalButtonText: "",

      indexList: [
        { label: "wifi", value: "wifi" },
        { label: "ethernet", value: "ethernet" },
        { label: "gprs", value: "gprs" },
      ],

      indexValue: [],

      typeList: [
        { label: "LPTO", value: "1" },
        { label: "HPTO", value: "10" },
        { label: "HPTH", value: "11" },
      ],

      typeValue: [],

      fullData: [],
      selectedSensors: [],

      disableMultiselect: false,
      active: false,

      settingValues: [],
    };
  },

  mounted() {
    //*************************************************** receive data */

    const config = { headers: { "Content-Type": "application/json" } };
    axios
      .post(
        Values.serverIp + "Device/GetDeviceSensors",
        JSON.stringify(this.$route.params.serialNumber),
        config
      )
      .then((response) => {
        if (response.status == 200) {
          //console.log(response.data);
          this.fullData = response.data;
          this.setIndexList(this.fullData);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },

  methods: {
    // ***************************************************************** submit form */
    submitForm() {
      console.log(this.settingValues);
      // axios
      //   .post(Values.serverIp + "Sensor/AddSensorAction", {
      //     SerialNumber: this.$route.params.serialNumber,
      //     SensorType: this.$route.params.sensorType,
      //     SensorIndex: this.$route.params.sensorIndex,
      //     Name: this.info.name,
      //     Min: JSON.parse(this.info.min),
      //     Max: JSON.parse(this.info.max),
      //     MinOperation: this.info.minOperation,
      //     MaxOperation: this.info.maxOperation,
      //   })
      //   .then((response) => {
      //     console.log(response);
      //     if (response.status == 200 && response.data == true) {
      //       // modal successfuly
      //       this.alertModal = true;
      //       this.alertModalTitle = "تغییرات";
      //       this.alertModalText = "تغییرات با موفقیت انجام شد.";
      //       this.alertModalColor = "success";
      //       this.alertModalButtonText = "تایید";
      //     } else {
      //       // modal unsuccessful edit change
      //       this.alertModal = true;
      //       this.alertModalTitle = "خطایی رخ داده";
      //       this.alertModalText = "پلاک یا اطلاعات وارد شده درست نمی باشد.";
      //       this.alertModalColor = "warning";
      //       this.alertModalButtonText = "تایید";
      //     }
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
    },
    // ***************************************************************** clear Form
    clearForm() {
      for (let i = 0; i < this.settingValues.length; i++) {
        this.settingValues[i].relayUp = "";
        this.settingValues[i].relayDown = "";
        this.settingValues[i].alarmUp = "";
        this.settingValues[i].alarmDown = "";
        this.settingValues[i].collibration = "";
      }
    },

    //******************************************************************** createList */
    createList() {
      for (let i = 0; i < this.info.minOperation.length; i++) {
        let opt = this.info.minOperation[i][0];
        let optItem = this.operationList.filter(function (item) {
          return item.value == opt;
        });

        let index = this.info.minOperation[i][1];
        let indexItem = this.indexList.filter(function (item) {
          return item.value == index;
        });

        let st = this.info.minOperation[i][2];
        let stItem = this.statusList.filter(function (item) {
          return item.value == st;
        });

        this.minSelectedOperatioList.push({
          operation: optItem[0].label,
          index: indexItem[0].label,
          status: stItem[0].label,
        });
      }
      for (let i = 0; i < this.info.maxOperation.length; i++) {
        let opt = this.info.maxOperation[i][0];
        let optItem = this.operationList.filter(function (item) {
          return item.value == opt;
        });

        let index = this.info.maxOperation[i][1];
        let indexItem = this.indexList.filter(function (item) {
          return item.value == index;
        });

        let st = this.info.maxOperation[i][2];
        let stItem = this.statusList.filter(function (item) {
          return item.value == st;
        });

        this.maxSelectedOperatioList.push({
          operation: optItem[0].label,
          index: indexItem[0].label,
          status: stItem[0].label,
        });
      }
    },

    redirectToCarsPage() {
      router.push({ name: "Cars" });
    },

    // ************************************** set index list
    setIndexList(data) {
      this.indexList = [];
      var tempMaxLength = data.carSensorTypes[0].values.length;
      for (var i = 0; i < data.carSensorTypes.length; i++) {
        if (data.carSensorTypes[i].values.length > tempMaxLength)
          tempMaxLength = data.carSensorTypes[i].values.length;
      }
      for (var i = 0; i < tempMaxLength; i++) {
        this.indexList.push({ label: "سنسور" + (i + 1), value: i + 1 });
      }
    },

    //*************************************** create table */
    createTable(data) {
      this.selectedSensors = [];
      console.log(this.fullData);
      for (var i = 0; i < this.fullData.carSensorTypes.length; i++) {
        if (
          this.fullData.carSensorTypes[i].values.length >= parseInt(data.value)
        ) {
          this.selectedSensors.push({
            name: this.fullData.carSensorTypes[i].sensorTypeName,
            type: this.fullData.carSensorTypes[i].sensorType,
          });

          this.settingValues.push({
            type: this.fullData.carSensorTypes[i].sensorType,
            relayUp: "",
            relayDown: "",
            alarmUp: "",
            alarmDown: "",
            collibration: "",
          });
        }
      }
    },
  },
};
</script>

<style></style>
